import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { environment } from 'src/environments/environment';
import { SwitchOrganizationsService } from './core/services/switch-organizations.service';
import { Router } from '@angular/router';
import { API_VERSIONS } from './shared/consts/api-versions.const';

@Injectable()
export class UserInterceptorInterceptor implements HttpInterceptor {
  protected readonly publicApiUrls = [
    'api/menus',
    `api/${API_VERSIONS.MENUS}/menus`,
  ];
  protected readonly publicRoutes = ['customer-products-selection'];
  domain: any = environment.domain;
  CentralDomain: any = environment.centralDomain;
  subDomainName: any = '';
  constructor(
    private authService: AuthService,
    private _switchOrg: SwitchOrganizationsService,
    private router: Router
  ) {
    let subDomain = window.location.origin.split('://')[1].split('.')[0];
    if (
      window.location.origin.includes(`.${this.domain}`) &&
      (subDomain != this.CentralDomain || !this.CentralDomain)
    ) {
      this.subDomainName = window.location.origin.split('://')[1].split('.')[0];
    }
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const centralToken = this._switchOrg.centralToken;
    const AuthToken = centralToken
      ? centralToken
      : this.authService.getUserToken();
    const subDomain = this.authService.getUserObj()?.sub_domain;

    const savedPublicDomain = this.authService.getPublicDomain();
    let headers = req.headers;

    const isPublicEndpoint = req?.url?.includes('/public/');
    if (!headers.has('Authorization') && !isPublicEndpoint) {
      headers = headers.append('Authorization', 'Bearer ' + AuthToken);
    }
    let tenant =
      subDomain || this.subDomainName || localStorage.getItem('domain');

    const isPublicApiUrl = this.publicApiUrls?.some((url) =>
      req?.url?.includes(url)
    );
    const isPublicRoute = this.publicRoutes?.some((url) =>
      this.router.url?.includes(url)
    );
    if (isPublicApiUrl && isPublicRoute) {
      tenant = savedPublicDomain;
    }

    if (tenant && !headers.has('X-Tenant') && tenant != 'dashboard') {
      headers = headers.append('X-Tenant', tenant);
    }

    // Add sorting parameter to all /paging APIs
    let modifiedReq = req;
    if (req.url.includes('/paging')) {
      const url = new URL(req.url, window.location.origin);
      if (!url.searchParams.has('sort')) {
        url.searchParams.append('sort', 'name');
      }
      modifiedReq = req.clone({
        url: url.toString().replace(window.location.origin, ''),
        headers: headers,
        withCredentials: req.withCredentials,
      });
    } else {
      modifiedReq = req.clone({
        headers: headers,
        withCredentials: req.withCredentials,
      });
    }

    return next.handle(modifiedReq);
  }
}
